module.exports = __webpack_public_path__ + "static/fonts/LavaPro-Reg.1a1a10c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/LavaPro-Reg.ttf
// module id = qb0S
// module chunks = 0